const Token = require('markdown-it/lib/token');
const escapeHtml = require('stringify-entities').escape;

const fieldDescriptionPattern = /^{{([^\/]+)\/([^\/]+)}}$/;

const parseMeta = meta => {
  const parseTitle = str => {
    const m = str.match(/title="(.+?)"/);
    if (!m || m.length !== 2) {
      return null;
    }

    return m[1];
  };

  const result = {};

  const title = parseTitle(meta);
  if (title) {
    result.title = title;
  }

  return result;
};

let templateNo = 1;

module.exports = md => {
  md.block.ruler.before('paragraph', 'custom_format_comment', (state, startLine, endLine) => {
    const expectOpenerPattern = /^\[custom_format_comment.+\]$/;
    const expectCloser = '[/custom_format_comment]';

    const firstLine = state.getLines(startLine, startLine + 1, state.blkIndent, false);
    if (!expectOpenerPattern.test(firstLine)) {
      return false;
    }

    const meta = parseMeta(state.getLines(startLine, startLine + 1, state.blkIndent, false));
    const commentFormTitle = meta.title;
    if (!commentFormTitle) {
      return false;
    }

    let closeFlag = false;

    let closerLine;
    let content = '';

    for (closerLine = startLine + 1; closerLine <= endLine; closerLine++) {
      const closerStart = state.bMarks[closerLine] + state.tShift[closerLine];
      if (state.src.substr(closerStart, expectCloser.length) === expectCloser) {
        closeFlag = true;
        break;
      }

      content += state.getLines(closerLine, closerLine + 1, state.blkIndent, false) + '\n';
    }

    if (!closeFlag) {
      return false;
    }

    const contentTokens = [];
    state.md.block.parse(content, state.md, state.env, contentTokens);

    const tokensToBePushed = [];
    const descriptorIDs = [];
    let isValidFormat = true;

    for (let index = 0; index < contentTokens.length; index++) {
      const t = contentTokens[index];

      if (t.type !== 'inline') {
        tokensToBePushed.push(t);
        continue;
      }

      const m = t.content.match(fieldDescriptionPattern);
      if (!m || m.length !== 3) {
        tokensToBePushed.push(t);
        continue;
      }

      const descriptorType = m[1].trim();
      const descriptorID = m[2].trim();

      if (descriptorIDs.includes(descriptorID)) {
        isValidFormat = false;
        break;
      }

      descriptorIDs.push(descriptorID);

      const descriptorDivToken = new Token('html_inline', '', 0);
      descriptorDivToken.content = `<div data-descriptor-id=${escapeHtml(descriptorID)} data-descriptor-type=${escapeHtml(descriptorType)}></div>`;

      tokensToBePushed.push(descriptorDivToken);
    }

    if (!isValidFormat) {
      return false;
    }

    const customFormatCommentOpen = state.push('custom_format_comment_open', 'template', 1);
    customFormatCommentOpen.attrs = [['id', `kamigame_custom_format_comment_template_${templateNo}`], ['class', 'kamigame_custom_format_comment_template'], ['data-comment-template-no', templateNo], ['data-title', escapeHtml(commentFormTitle)]];
    customFormatCommentOpen.block = true;

    tokensToBePushed.forEach(t => state.tokens.push(t));

    const formatCommentClose = state.push('custom_format_comment_close', 'template', -1);
    formatCommentClose.block = true;

    templateNo++;
    state.line = closerLine + 1;
    return true;
  });
};
